import { render, staticRenderFns } from "./LabelZip.vue?vue&type=template&id=59043ce1"
import script from "./LabelZip.vue?vue&type=script&lang=ts"
export * from "./LabelZip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports